/* Auto generated by gulp-typescript-template */

export const DragAndDropQuiz = `<div class="DragAndDropQuiz"><div class="dropAreas"></div></div>`;
export const DropArea = `<div class="DropArea"><div class="items"></div></div>`;
export const LabelledDropArea = `<div class="DropArea -labelled"><div class="label [[{ '_hidden': !isEmpty }]]">[[label]]</div><div class="items"></div></div>`;
export const TextItem = `<div class="TextItem [[{ '-show-correctness': showCorrectness, '-in-correct-drop-area': showCorrectness && inCorrectDropArea }]]"> [[text]]</div>`;
